import { type ReactNode, useState } from "react";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import { grey } from "@mui/material/colors";

/**
 * The top bar's less-used controls — referrals, AI visualisation, fax, email — behind one
 * "More" button when the window is too narrow for them all (ENG-2009). Styled like the
 * bar's own mobile menu, which already hosts these same components in a popover.
 */
export default function TopBarMoreMenu({ children }: { children: ReactNode }) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  return (
    <>
      <Tooltip title="More">
        <IconButton
          size="small"
          aria-label="More"
          aria-haspopup="true"
          aria-expanded={Boolean(anchor)}
          data-testid="top-bar-more-button"
          onClick={(event) => setAnchor(event.currentTarget)}
        >
          <MoreHorizIcon />
        </IconButton>
      </Tooltip>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ mt: 1 }}
      >
        <Stack
          direction="row"
          alignItems="center"
          gap={1}
          sx={{
            p: 1.5,
            background: grey[50],
            border: `solid 1px ${grey[300]}`
          }}
        >
          {children}
        </Stack>
      </Popover>
    </>
  );
}
